module.exports = __webpack_public_path__ + "media/images/emblems/Innertkirchen-coat_of_arms-6d18d8c8bbd5c76a4f3cb5206fb518a0.svg";